import { redisGetHandler } from "../utils/redis";

/**
 * Данные карты сайта из нового бэкенда (nestFarkopDatabase, config.SERVICE_DATABASE_API_URL).
 * Кеш Redis: hash `Api_sitemap`. Структура секций (коды/URL/иерархия) берётся отдельно
 * из Api.sections.getSections (bxApi) — в новом бэкенде таблицы секций нет.
 */
export default (axios: any, config: any) => ({
  // Где вызывается: сервер. Активные товары секции ([{ code, lastmod }]).
  async getProductCodes(
    Redis: any,
    sectionId: number | string,
    reset = false,
  ) {
    return redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      `/sitemap/products?sectionId=${sectionId}`,
      reset,
    );
  },
  // Где вызывается: сервер. Товары секции бренда Baltex.
  async getBaltexProductCodes(
    Redis: any,
    sectionId: number | string,
    reset = false,
  ) {
    return redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      `/sitemap/baltex-products?sectionId=${sectionId}`,
      reset,
    );
  },
  // Где вызывается: сервер. Сегменты filter-URL марок/моделей/кузовов секции.
  async getSectionModelSegments(
    Redis: any,
    sectionId: number | string,
    reset = false,
  ) {
    return redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      `/sitemap/section-models?sectionId=${sectionId}`,
      reset,
    );
  },
  // Где вызывается: сервер. Сегменты марок секции с датами ([{ segment, lastmod }]).
  async getSectionModelItems(
    Redis: any,
    sectionId: number | string,
    reset = false,
  ) {
    return redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      `/sitemap/section-models?sectionId=${sectionId}&withLastmod=true`,
      reset,
    );
  },
  // Где вызывается: сервер. Сегменты свойств секции с датами.
  async getSectionFilterItems(
    Redis: any,
    sectionId: number | string,
    reset = false,
  ) {
    return redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      `/sitemap/section-filters?sectionId=${sectionId}&withLastmod=true`,
      reset,
    );
  },
  // Где вызывается: сервер. Дата изменения раздела ({ lastmod }).
  async getSectionLastmod(
    Redis: any,
    sectionId: number | string,
    reset = false,
  ) {
    return redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      `/sitemap/section-lastmod?sectionId=${sectionId}`,
      reset,
    );
  },
  // Где вызывается: сервер. Сегменты filter-URL свойств секции.
  async getSectionFilterSegments(
    Redis: any,
    sectionId: number | string,
    reset = false,
  ) {
    return redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      `/sitemap/section-filters?sectionId=${sectionId}`,
      reset,
    );
  },
  // Где вызывается: сервер. Активные новости ([{ code, lastmod }]).
  async getNews(Redis: any, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      `/sitemap/news`,
      reset,
    );
  },
});
